import { render, staticRenderFns } from "./iconSurvey.vue?vue&type=template&id=34e049a9&scoped=true"
import script from "./iconSurvey.vue?vue&type=script&lang=js"
export * from "./iconSurvey.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e049a9",
  null
  
)

export default component.exports